import { all } from 'redux-saga/effects';

import approvalWorkflowWatcher from './approval-worflow-saga';

export default function* rootSaga(action) {
	yield all([approvalWorkflowWatcher(action)]);
}
